import * as React from "react";
import * as ReactDOM from "react-dom";
import Banner from "../components/Banner";

// For hot reloading:
declare var module: any;
if (module.hot) {
  module.hot.accept();
}

// Doing this with plain old JS (not JQuery) to avoid dependency on JQuery.
const components = document.getElementsByClassName("bannerComponent");

for (let i = 0; i < components.length; i++) { // tslint:disable-line prefer-for-of
  const elem = components[i];
  const cdnLocation = (elem.attributes["data-cdn-location"] || {}).nodeValue;
  const portletInstanceId = (elem.attributes["data-portlet-instance-id"] || {}).nodeValue;
  const isCarouselMode = ((elem.attributes["data-is-carousel-mode"] || {}).nodeValue || "").trim().toLowerCase() === "true";
  const dangerousHtmlRegexPattern: string = elem.attributes["data-dangerous-html-regex-pattern"]?.nodeValue?.trim() || "";
  const render = (Component) => {
    ReactDOM.render(
      <Component portletInstanceId={portletInstanceId} isCarouselMode={isCarouselMode} cdnLocation={cdnLocation} dangerousHtmlRegexPattern={dangerousHtmlRegexPattern} />,
      elem,
    );
  };

  render(Banner);
}
